// Customer-facing exceptions to the workbook's category-level illustrative
// booking patterns and settings. Keep the source catalogue unchanged.
export const professionPresentationOverrides = {
  MP015: { bookingPattern: 'Event cover or scheduled visit', serviceSetting: 'Event site, home or care setting' },

  MP052: { serviceSetting: 'Registered or licensed premises, where required' },
  MP060: { serviceSetting: 'Registered or licensed premises, where required' },
  MP063: { serviceSetting: 'Registered or licensed premises, where required' },

  MP066: { bookingPattern: 'Fitting appointment', serviceSetting: 'Home, shop or suitable fitting room' },
  MP067: { bookingPattern: 'Fitting or making project', serviceSetting: 'Studio or agreed fitting location' },
  MP068: { bookingPattern: 'Consultation or styling session' },
  MP069: { bookingPattern: 'Shopping appointment', serviceSetting: 'Shop or agreed meeting place' },
  MP071: { bookingPattern: 'Fitting or alteration job', serviceSetting: 'Tailor’s studio, home or workplace' },

  MP072: { serviceSetting: 'Road, track or suitable training venue' },
  MP076: { serviceSetting: 'Suitable outdoor site or activity venue' },

  MP108: { bookingPattern: 'Support visit or birth attendance', serviceSetting: 'Family home or agreed birth setting' },
  MP109: { bookingPattern: 'Family support visit', serviceSetting: 'Family home or community setting' },
  MP110: { bookingPattern: 'Feeding consultation or follow-up', serviceSetting: 'Family home or suitable private room' },
  MP113: { bookingPattern: 'Play session or activity block', serviceSetting: 'Family home or suitable play setting' },

  MP114: { bookingPattern: 'Supervised contact session', serviceSetting: 'Agreed contact centre or family setting' },
  MP115: { bookingPattern: 'Companionship visit or outing' },
  MP116: { bookingPattern: 'Personal assistance visit or shift' },
  MP117: { bookingPattern: 'Support visit or planning meeting', serviceSetting: 'Home, hospice or agreed care setting' },
  MP118: { bookingPattern: 'Care visit or shift' },
  MP119: { bookingPattern: 'Skills lesson or support visit' },
  MP120: { bookingPattern: 'Capacity assessment appointment', serviceSetting: 'Home, care setting or private room' },
  MP121: { bookingPattern: 'Advocacy meeting or casework' },
  MP122: { bookingPattern: 'Assessment or support visit' },

  MP128: { bookingPattern: 'Aquarium maintenance visit', serviceSetting: 'Home or workplace aquarium' },
  MP129: { bookingPattern: 'Training session or follow-up', serviceSetting: 'Home, training ground or outdoor setting' },
  MP130: { bookingPattern: 'Walk or recurring visit', serviceSetting: 'Home pick-up and outdoor route' },
  MP131: { bookingPattern: 'Grooming appointment', serviceSetting: 'Home or suitable mobile grooming setup' },
  MP132: { bookingPattern: 'Care visit or sitting stay', serviceSetting: 'Pet’s home or agreed care setting' },
  MP136: { serviceSetting: 'Apiary, farm or other bee site' },

  MP198: { bookingPattern: 'Incident clean or planned job' },
  MP203: { bookingPattern: 'Damage assessment or restoration job', serviceSetting: 'Affected property or restoration site' },
  MP204: { bookingPattern: 'Graffiti removal visit or quote' },
  MP206: { bookingPattern: 'Housekeeping visit or regular block', serviceSetting: 'Client home or agreed property' },
  MP207: { bookingPattern: 'Collection, laundry service or delivery', serviceSetting: 'Customer address or laundry workspace' },
  MP208: { bookingPattern: 'Assessment or remediation job', serviceSetting: 'Affected property or work site' },

  MP211: { bookingPattern: 'Removal quote or planned project', serviceSetting: 'Property or controlled work site' },
  MP213: { bookingPattern: 'Site survey or treatment programme', serviceSetting: 'Affected land or outdoor site' },
  MP214: { bookingPattern: 'Spill response or remediation project', serviceSetting: 'Affected site or outdoor area' },
  MP215: { bookingPattern: 'Tank inspection or service visit', serviceSetting: 'Oil tank at home or work site' },
  MP216: { bookingPattern: 'Pest survey or treatment visit' },
  MP217: { bookingPattern: 'Septic tank inspection or service visit' },
  MP219: { bookingPattern: 'Inspection, sampling or service visit', serviceSetting: 'Building or plant room' },

  MP220: { bookingPattern: 'Tree survey or planned work' },
  MP221: { bookingPattern: 'Fencing quote or installation project' },
  MP222: { bookingPattern: 'Garden design consultation or project' },
  MP223: { bookingPattern: 'Repair visit or workshop job', serviceSetting: 'Workshop or equipment location' },
  MP225: { bookingPattern: 'Weather-dependent callout or contract', serviceSetting: 'Road, path, car park or other site' },
  MP227: { bookingPattern: 'Irrigation survey, installation or service' },
  MP228: { bookingPattern: 'Landscape design consultation or project' },
  MP229: { bookingPattern: 'Landscaping quote or project' },
  MP230: { bookingPattern: 'Lawn treatment or recurring visit' },
  MP231: { bookingPattern: 'Paving quote or project' },
  MP232: { bookingPattern: 'Pond service or installation project' },
  MP233: { bookingPattern: 'Service visit or planned maintenance', serviceSetting: 'Pool or spa at home or venue' },

  MP254: { serviceSetting: 'Farm, yard or machinery site' },
  MP255: { serviceSetting: 'Driveway, workplace or suitable repair site' },
  MP256: { serviceSetting: 'Home, workplace or repair workshop' },
  MP257: { serviceSetting: 'Boat, marina or boatyard' },
  MP258: { serviceSetting: 'Roadside, driveway or recovery destination' },
  MP259: { serviceSetting: 'Driveway, pitch or storage site' },
  MP260: { serviceSetting: 'Depot, yard or work site' },
  MP261: { serviceSetting: 'Boat, marina or boatyard' },
  MP262: { serviceSetting: 'Driveway, garage or suitable vehicle site' },
  MP263: { serviceSetting: 'Driveway, garage or suitable workshop' },
  MP264: { serviceSetting: 'Work site, yard or depot' },
  MP265: { serviceSetting: 'Driveway, yard or trailer storage site' },
  MP266: { serviceSetting: 'Driveway, roadside or fleet yard' },
  MP267: { serviceSetting: 'Suitable repair site or workshop' },
  MP268: { serviceSetting: 'Driveway, workplace or vehicle workshop' },
  MP269: { serviceSetting: 'Vehicle site, depot or workshop' },
  MP270: { serviceSetting: 'Driveway, workplace or suitable wash site' },
  MP271: { bookingPattern: 'Wrapping appointment or project', serviceSetting: 'Suitable workshop or indoor fitting site' },

  MP274: { serviceSetting: 'Workshop, laboratory or equipment site' },
  MP276: { serviceSetting: 'Commercial kitchen or equipment site' },
  MP277: { serviceSetting: 'Laundry premises or equipment site' },
  MP280: { serviceSetting: 'Dental practice or equipment site' },
  MP283: { serviceSetting: 'Laboratory or equipment site' },
  MP284: { serviceSetting: 'Care setting or equipment site' },
  MP289: { serviceSetting: 'Vending machine site or workshop' },

  MP303: { bookingPattern: 'Clock repair or collection', serviceSetting: 'Workshop or clock location' },
  MP307: { bookingPattern: 'Restoration assessment or project', serviceSetting: 'Workshop or furniture location' },
  MP308: { bookingPattern: 'Leather repair or restoration job', serviceSetting: 'Workshop or item location' },
  MP309: { bookingPattern: 'Instrument repair or collection', serviceSetting: 'Workshop or instrument location' },
  MP310: { bookingPattern: 'Piano tuning visit', serviceSetting: 'Piano’s location' },
  MP311: { bookingPattern: 'Machine repair or collection', serviceSetting: 'Workshop or sewing machine location' },
  MP314: { bookingPattern: 'Sharpening visit or collection', serviceSetting: 'Workshop or tool location' },
  MP315: { bookingPattern: 'Upholstery repair or project', serviceSetting: 'Workshop or furniture location' },

  MP317: { bookingPattern: 'Accessible passenger journey or return trip' },
  MP318: { bookingPattern: 'Boat collection, transport or delivery' },
  MP319: { bookingPattern: 'Caravan relocation or delivery' },
  MP320: { bookingPattern: 'Chauffeur journey or event transfer' },
  MP321: { bookingPattern: 'Group journey or event transfer' },
  MP322: { bookingPattern: 'Parcel collection or delivery' },
  MP323: { bookingPattern: 'Machinery move or relocation project' },
  MP324: { bookingPattern: 'Meal delivery round or recurring service' },
  MP325: { bookingPattern: 'Planned patient journey or return trip' },
  MP326: { bookingPattern: 'Pet collection or transport journey' },
  MP327: { bookingPattern: 'Passenger journey or planned transfer' },
  MP328: { bookingPattern: 'Removal quote or planned move' },
  MP329: { bookingPattern: 'Artwork handling or transport project' },
  MP330: { bookingPattern: 'Passenger journey or planned pickup' },
  MP331: { bookingPattern: 'Vehicle collection or delivery' },

  MP332: { bookingPattern: 'Scheduled field work or contract', serviceSetting: 'Farm, field or agricultural site' },
  MP333: { bookingPattern: 'Drainage survey or installation project', serviceSetting: 'Farm, land or drainage site' },

  MP340: { bookingPattern: 'Restoration assessment or project', serviceSetting: 'Workshop, client premises or collection site' },
  MP341: { bookingPattern: 'Conservation assessment or project', serviceSetting: 'Conservation studio or artwork location' },
  MP342: { bookingPattern: 'Installation visit or project', serviceSetting: 'Gallery, home or installation site' },
  MP346: { bookingPattern: 'Site visit or mural project', serviceSetting: 'Wall or mural site' },
  MP350: { bookingPattern: 'Production booking or project', serviceSetting: 'Studio, set or production venue' },
  MP351: { bookingPattern: 'Signwriting visit or project', serviceSetting: 'Premises, vehicle or workshop' },

  MP354: { bookingPattern: 'Performance or production booking', serviceSetting: 'Venue, studio or filming location' },
  MP370: { bookingPattern: 'Order, delivery or event', serviceSetting: 'Florist studio, client site or event venue' },
  MP377: { bookingPattern: 'Shift or site assignment', serviceSetting: 'Venue, business site or event site' },
  MP381: { bookingPattern: 'Scheduled tour', serviceSetting: 'Visitor site or tour route' },

  MP383: { serviceSetting: 'Event venue or catered site' },
  MP384: { serviceSetting: 'Food truck pitch or event site' },
  MP385: { serviceSetting: 'Coffee cart, client site or event venue' },
  MP386: { serviceSetting: 'Venue or event bar setup with required permissions' },
  MP388: { serviceSetting: 'Client home, restaurant or event venue' },

  MP390: { bookingPattern: 'Valuation, auction or event', serviceSetting: 'Auction venue, property or meeting place' },
  MP394: { bookingPattern: 'Viewing, valuation or property visit', serviceSetting: 'Property, office or agreed meeting place' },
  MP408: { bookingPattern: 'Document service assignment', serviceSetting: 'Recipient’s address or other service location' },
  MP412: { bookingPattern: 'Valuation visit or assignment', serviceSetting: 'Property, business site or meeting place' },

  MP414: { bookingPattern: 'Errand or collection', serviceSetting: 'Client address, shop or collection point' },
  MP415: { bookingPattern: 'Arrangement meeting or funeral service', serviceSetting: 'Family home, funeral premises or service venue' },
  MP416: { bookingPattern: 'Property staging visit or project', serviceSetting: 'Client property or staging site' },
  MP417: { bookingPattern: 'House-sitting stay or agreed period', serviceSetting: 'Client home' },
  MP418: { bookingPattern: 'Administration appointment or ongoing work' },
  MP419: { bookingPattern: 'Support block or ongoing assignment' },
  MP420: { bookingPattern: 'Organising visit or project' },
  MP421: { bookingPattern: 'Relocation consultation or project', serviceSetting: 'Home, workplace or move destination' },
  MP422: { bookingPattern: 'Move-planning visit or project', serviceSetting: 'Home, care setting or destination' },

  MP427: { bookingPattern: 'Vessel survey or inspection visit', serviceSetting: 'Vessel, marina or boatyard' },
  MP429: { bookingPattern: 'Service visit or installation', serviceSetting: 'Retail or hospitality site' },
};

export function getProfessionPresentation(profession) {
  const override = professionPresentationOverrides[profession.id] || {};
  const categorySetting = profession.categorySlug === 'hair-beauty-and-body-art'
    ? 'Salon, treatment premises or agreed location, where permitted'
    : profession.serviceSetting;
  return {
    bookingPattern: override.bookingPattern || profession.bookingPattern,
    serviceSetting: override.serviceSetting || categorySetting,
  };
}
